import { Injectable } from '@angular/core';
import { FluxRequestGateway } from './flux-request-gateway';

@Injectable({ providedIn: 'root' })
export class CommandGatewayService extends FluxRequestGateway {
  protected path = '/command';
}
